import React, { useMemo } from "react";
import { Container } from "react-bootstrap";
import CmsTopBar from "components/cmslayout/CmsTopBar";
import DataLiteTable from "./components/DataLiteTable";
import ProgressTextBar from "./components/ProgressTextBar";
import SectionHeader from "./components/SectionHeader";
import { repPerformanceData } from "./mockData";
import type { DataLiteColumn, RepPerformanceItem } from "./types";

const getPercentage = (item: RepPerformanceItem) => {
  if (item.target <= 0) return 0;
  return Math.round((item.actual / item.target) * 100);
};

const RepPerformancePage: React.FC = () => {
  const columns = useMemo<DataLiteColumn<RepPerformanceItem>[]>(
    () => [
      {
        key: "name",
        title: "Rep Name",
        render: (item) => <strong>{item.name}</strong>,
      },
      {
        key: "target",
        title: "Target",
        className: "data-lite-number-cell",
        render: (item) => item.target,
      },
      {
        key: "actual",
        title: "Actual",
        className: "data-lite-number-cell",
        render: (item) => item.actual,
      },
      {
        key: "percentage",
        title: "%",
        render: (item) => <ProgressTextBar value={getPercentage(item)} />,
      },
    ],
    [],
  );

  return (
    <React.Fragment>
      <CmsTopBar title="Registration of Users by Reps" />

      <Container fluid className="dashboard-wrap">
        <Container fluid className="px-3 py-4">
          <div className="data-lite-page">
            <SectionHeader
              title="Rep Performance Tracking"
              description="Text-first snapshot of registration target completion."
            />

            <DataLiteTable
              columns={columns}
              data={repPerformanceData}
              rowKey={(item) => item.id}
              emptyText="No rep performance data yet."
            />
          </div>
        </Container>
      </Container>
    </React.Fragment>
  );
};

export default RepPerformancePage;
